import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CiStickyNote } from 'react-icons/ci';
import { MdOutlineNotes } from 'react-icons/md';
import { ActionButton, EmptyContent, VaultNote } from '../../components';
import s from './style.css';
import { vault } from '../../actions';
import ContextMenu from '../../components/ContextMenu';
import { API } from '../../actions/URL';
import { isCloseToBottom } from '../../utils';
let loadingMore = false;
const NotesScreen = (props) => {
    useEffect(() => {
        props.fetchVaultNotes(`${API}/api/fetch-vault-notes/`, true);
    }, []);
    const handleScroll = () => {
        if (isCloseToBottom() && !loadingMore && props.url) {
            loadingMore = true;
            props.fetchVaultNotes(props.url, false, () => (loadingMore = false));
        }
    };
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [props.url]);
    const handlePhotoChange = async (e) => {
        e.preventDefault();
        if (e.target.files) {
            props.uploadFiles(Array.from(e.target.files), props.isBasic, props.currentFolder.id);
        }
    };
    const history = useHistory();
    const [contextMenuVisible, setContextMenuVisible] = useState(false);
    const [contextMenuPosition, setContextMenuPosition] = useState({ x: 0, y: 0 });
    const [contextItem, setContextItem] = useState(null);
    const handleMenuItemClick = () => {
        setContextMenuVisible(false);
    };
    const handleContextMenu = (e, isDotClick, item) => {
        e.preventDefault();
        setContextMenuVisible(true);
        setContextMenuPosition({ x: isDotClick ? e.pageX - 310 : e.pageX + 10, y: e.pageY });
        setContextItem(item);
    };
    const handleEmptyClick = () => {
        setContextMenuVisible(false);
    };
    return (React.createElement("div", { className: s.main, id: 'main', onClick: handleEmptyClick, role: 'button', tabIndex: 0, onKeyDown: (e) => {
            if (e.key === 'Enter' || e.key === ' ')
                handleEmptyClick();
        } },
        contextMenuVisible && (React.createElement(ContextMenu, { x: contextMenuPosition.x, y: contextMenuPosition.y, onItemClick: handleMenuItemClick, item: contextItem, type: 'note' })),
        React.createElement("div", { className: s.screenContainer },
            React.createElement("div", { className: s.stackContainer },
                React.createElement("div", { className: s.stackItem },
                    React.createElement("button", { type: 'button', className: s.stackItemTitle }, "Notes"))),
            React.createElement("div", { style: { flexDirection: 'row', display: 'flex' } },
                React.createElement(ActionButton, { onClick: () => history.push('/vault/notes/create-note'), text: 'New note', icon: React.createElement(CiStickyNote, { fontSize: 20 }) })),
            React.createElement("input", { type: 'file', multiple: true, id: 'upload', style: { display: 'none' }, onChange: handlePhotoChange }),
            props.notes.length > 0 ? (React.createElement("div", { style: { display: 'flex', flexDirection: 'column', paddingBottom: '20px', paddingRight: '2px' } }, props.notes.map((item, index) => (React.createElement(VaultNote, { note: item, key: `${index}`, handleContextMenu: (e, isDotClick) => handleContextMenu(e, isDotClick, item) }))))) : (React.createElement(EmptyContent, { icon: React.createElement(MdOutlineNotes, { size: 100, color: 'lightgrey' }), text: 'Secret notes, hidden treasures, all secured in your private Vault.', action: React.createElement(ActionButton, { onClick: () => history.push('/vault/notes/create-note'), text: 'New note', icon: React.createElement(CiStickyNote, { fontSize: 20 }), style: { alignSelf: 'center', marginBottom: 20 } }) })))));
};
const mapStateToProps = (state) => {
    const currentFolder = state.appTemp.isSearching
        ? { id: 'search' }
        : state.appTemp.folderStack[state.appTemp.folderStack.length - 1];
    return {
        notes: Object.values(state.vaultNotes),
        url: state.url.vaultNotesUrl,
        isBasic: state.auth.user?.subscription === 'basic',
        currentFolder,
    };
};
const connector = connect(mapStateToProps, { ...vault });
export default connector(NotesScreen);
